/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuRadioSelectList_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly localizedFilterName: string | null;
        readonly canBeDismissed: boolean | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly linkReference: string | null;
            readonly count: number | null;
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "SbSharedRefineMenuRadioSelectList_itemSearch";
};
export type SbSharedRefineMenuRadioSelectList_itemSearch$data = SbSharedRefineMenuRadioSelectList_itemSearch;
export type SbSharedRefineMenuRadioSelectList_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuRadioSelectList_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuRadioSelectList_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuRadioSelectList_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "localizedFilterName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "canBeDismissed",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "linkReference",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "count",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '06f01a094592b24a0581478912ba24ca';
export default node;
